import { render, staticRenderFns } from "./ExamOptionView.vue?vue&type=template&id=06da2ca6&scoped=true&"
import script from "./ExamOptionView.vue?vue&type=script&lang=js&"
export * from "./ExamOptionView.vue?vue&type=script&lang=js&"
import style0 from "./ExamOptionView.vue?vue&type=style&index=0&id=06da2ca6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da2ca6",
  null
  
)

export default component.exports